import {Transerializable} from '@eventops/athlinks-get-or'
/**
 * timeInMillis: milliseconds from the Epoch in UTC
 * timeZone: ISO timezone standard as used by moment.js/timezone (America/Denver, et cetera)
 *   see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
 */
export interface ICalendarTime {
  timeInMillis: number,
  timeZone: string
}

export class CalendarTime extends Transerializable implements ICalendarTime {
  public timeInMillis = 0
  public timeZone = ''
}